import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Typography, useMediaQuery, Grid, useTheme, Box } from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'

import { fileActions, validationActions, documentsActions } from '../../store/actions'
import { docApprovalFunction } from './DocApprovalFunction'
import { coreFunctions } from '../../utils'//funciones del nucleo
import VisorPDF from "../../components/Visor/VisorPDF.js";
import {
    GenericContainer, UseImage, GenericStatusElement, GenericButtonList,
    CustomControls, CustomCounterAppBar, CustomLoadingOverlay, GenericDialog, AlertConfirm
    , Buttons
} from '../../components'


import { useStyles } from './DocApprovalStyles'
import { useTranslation } from 'react-i18next'

export default function DocumentApprovalComponent(props) {
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [loadView, setLoadView] = useState(false)
    const [docs, setDocs] = useState([])
    const [estatusText, setEstatusText] = useState("Validación documental")
    const [timerSeconds, setTimerSeconds] = useState(15)
    const [activeFileInfo, setActiveFileInfo] = useState(false)
    const [fileId, setFileId] = useState(null)
    const { t } = useTranslation();

    const auth = useSelector(state => state.Authentication)
    // const wf = useSelector(state => state.Workflow)
    const file = useSelector(state => state.FileInfo)
    const docValidation = useSelector(state => state.DocumentValidation)

    useEffect(() => {
        setFileId(location.state.folioId)
        dispatch(fileActions.GetFileInfo(location.state.folioId))
        setActiveFileInfo(true)
    }, [])

    useEffect(() => {
        if (timerSeconds == 0) {
            //Realiza la peticion
            dispatch(fileActions.GetFileInfo(fileId))
            setTimerSeconds(15)
            setActiveFileInfo(true)
        }
        // salir cuando lleguemos a 0
        if (!timerSeconds) return;

        // save intervalId para borrar el intervalo cuando el componente vuelve a renderizar
        const intervalId = setInterval(() => {
            setTimerSeconds(timerSeconds - 1);
        }, 1000);

        // clear interval al volver a renderizar para evitar pérdidas de memoria
        return () => clearInterval(intervalId);
    }, [timerSeconds]);

    useEffect(() => {
        setLoadView(file.loading)
        if (!file?.items?.IsAssignedUser)   navigate('/auth/')
        if (file.items != undefined && activeFileInfo) {
            console.log("file.itemsDocsToApproved", file.itemsDocsToApproved)
            console.log("file.file.itemsValidation.ValidationFile ", file.itemsValidation.ValidationFile)
            console.log("file", file.items.Stage?.Name)
            setLoadView(false)
            if (file.itemsValidation.ValidationFile == true || file.items.Stage?.Name == "Firma de documentos" || file.items.Stage?.Name != "Validación Documental") {
                let nextStage = file.items.Stage
                let stageName = nextStage.Name
                let stageId = nextStage.Id
                let stage = file.items
                let folioId = file.items.Id
                let nextComponent = coreFunctions.GetLegoNext(stageName)
                console.log("{ auth ,navigate,nextComponent, stageName, stageId, stage, folioId }", { auth, navigate, nextComponent, stageName, stageId, stage, folioId })
                // setStateActual(nextComponent)
                docApprovalFunction.nextStage({ auth, navigate, nextComponent, stageName, stageId, stage, folioId })
            }
            setDocs(file.itemsDocsToApproved)          
            setEstatusText(file.items.Status)
            // console.log('file', file.items)

        }
    }, [file])

    return (<GenericContainer>
        {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}
        <Typography variant="h6" gutterBottom >Estatus:</Typography>
        <Typography variant="subtitle1" gutterBottom >{estatusText}</Typography>
        {docs.length > 0 && docs?.map((doc) => {
                    return <DocApprovalModal name={doc.Name}
                        approved={doc.Document?.Validation?.Approved ? 'Aprobado' : doc.Document?.Validation?.Approved === false ? 'Rechazado' : doc.Document?.Validation?.Approved === null ? 'En aprobación' : ''}
                        docStatus={doc.Document?.Validation?.Approved ? 1 : doc.Document?.Validation?.Approved === false ? 2 : doc.Document?.Validation?.Approved === null ? 3 : ''}
                        id={doc.Document?.Id}
                        folio={location.state.folioId}
                        properties={file.items?.Stage?.Properties}
                    />
                })}
    </GenericContainer>)
}



export const DocApprovalModal = ({ name, approved, docStatus, id, folio, properties }) => {
    const [openModal, setOpenModal] = useState(false);
    const [pages, SetnumPages] = useState([]);
    const [sendRes, setSendRes] = useState(false);
    const [openApproved, setOpenApproved] = useState(false);
    const [openRejected, setOpenRejected] = useState(false);
    const [loadView, setLoadView] = useState(false)
    const [showButtons, setShowButtons] = useState(false)

    const dispatch = useDispatch()

    const docValidation = useSelector(state => state.DocumentValidation)

    const matches = useMediaQuery('(min-width:750px)');
    const gridContainer = {} //mainStyles.gridStyle()
    const visualDoc = {} //mainStyles.docVisualButton()
    const theme = useTheme()
    const location = useLocation()
    const classes = {} //mainStyles.bodyStyles()
    const localStyles = {}//useStyles()



    const handleClose = () => {
        dispatch(fileActions.GetFileInfo(folio))
        setOpenModal(false);
    };

    const setPages = ({ numPages }) => {
        for (let i = 1; i < numPages + 1; i++) {
            SetnumPages(pages => [...pages, i])
        }
    }

    useEffect(() => {
        if (docValidation.loading === true && sendRes) {
            setLoadView(true)
        }
        if (docValidation.error != undefined && sendRes) {
            alert(docValidation.error)
            setLoadView(false)
        }
        if (docValidation.items != undefined && sendRes) {
            if (docValidation.items.IsOk === true) {
                handleClose()
            }
        }
    }, [docValidation])

    //Reject or accept document
    const sendApproval = () => {
        setSendRes(true)
        dispatch(validationActions.SendDocumentValidation({
            Document_Id: id,
            Approved: true,
            Comments: "",
            ValidateFileComplete: true
        }))
    }

    const sendRejection = () => {
        setSendRes(true)
        dispatch(validationActions.SendDocumentValidation({
            Document_Id: id,
            Approved: false,
            Comments: "",
            ValidateFileComplete: true
        }))
    }

    useEffect(() => {
        // console.log("Porperties--------------Stage-------------Validation: ", properties)
        if (properties != undefined && properties != null) {
            let validationProp = properties.find(element => element.Name == "ValidationType")
            // console.log("validationProp---------: ", validationProp)
            setShowButtons(validationProp != undefined && validationProp != null && validationProp?.Value == "Portal" ? false : true)
        }
    }, [properties])

    return (<>
        <GenericButtonList
            key={`btn_key_1`}
            onClick={() => {
                SetnumPages([])
                setOpenModal(true);
            }} >
            <GenericStatusElement
                key={`list_element_key_2`}
                text={name}
                status={approved}
                statusColor={docStatus} />
        </GenericButtonList>
        <ModalProvedView open={openModal} HandleClose={handleClose}
            Approved={approved} Name={name} ShowButtons={showButtons} Id={id}
            sendApproval={sendApproval} sendRejection={sendRejection}
        />
    </>)
}

const ModalProvedView = (props) => {
    const localStyles = useStyles()

    const [loadView, setLoadView] = useState(false)

    const document = useSelector(state => state.DocumentView)

    const dispatch = useDispatch()
    const { t } = useTranslation();

    useEffect(() => {
        dispatch(documentsActions.GetDocument(props.Id))
    }, [props.Id])

    useEffect(() => {
        setLoadView(document?.loading)
        if (document.error != undefined) {
            // alert(docValidation.error)
            setLoadView(false)
        }
    }, [document])

    return (<GenericDialog open={props.open} onClose={props.HandleClose}
        title="Aprobación de documentos"
        content={<Box sx={{
            display: 'flex',
            position: 'relative',
            height: '80vh',
            flexDirection: "column",
        }}>
            {loadView || document.loading ? <CustomLoadingOverlay active={loadView ?? document.loading} text={t("general_loading_message")} /> : null}

            <Typography variant='subtitle1' >{props.Name}&nbsp;
                {props.Approved === 'Aprobado' ? <span style={{ color: 'green' }}>/{props.Approved}</span>
                    : props.Approved === 'Rechazado' ? <span style={{ color: 'red' }}>/{props.Approved}</span>
                        : ''}</Typography>
            {!document.loading && document.extension === '.mp4' ?
                <video className="videoClass" width="100%" height="90%" controls autoplay loop poster="fotograma.png">
                    <source src={document.items} type={document.type} />
                    <p>{t("unsupported_browser_message")}</p>
                </video>
                : <VisorPDF pdfUrl={document.items} />
            }

            {!props.ShowButtons || (props.Approved === 'Aprobado' || props.Approved === 'Rechazado') ?
                null
                : <div className={localStyles.buttonSection}>
                    <Buttons onClickConfirm={() => {

                        AlertConfirm(
                            {
                                icon: "success",
                                html: <Box>
                                    <Typography
                                        textAlign={"center"}
                                        variant="body1"
                                        sx={{ mt: 1, textAlign: "center", maxWidth: 400, mx: "auto" }}
                                    >
                                        Esta Acción no se podrá revertir, ¿Estas seguro de aprobar este documento?
                                    </Typography>
                                </Box>,
                                okbtntext: t("general_accept"),
                                notbtntext: t("general_cancel"),
                            },
                            (result) => {
                                if (result.isConfirmed) {
                                    props.sendApproval()
                                }
                            }
                        );

                    }}
                        ConfirmButtonText='Aprobar'
                        onClickCancel={() => {
                            AlertConfirm(
                                {
                                    icon: "success",
                                    html: <Box>
                                        <Typography
                                            textAlign={"center"}
                                            variant="body1"
                                            sx={{ mt: 1, textAlign: "center", maxWidth: 400, mx: "auto" }}
                                        >
                                            Esta Acción no se podrá revertir, ¿Estas seguro de rechazar este documento?
                                        </Typography>
                                    </Box>,
                                    okbtntext: t("general_accept"),
                                    notbtntext: t("general_cancel"),
                                },
                                (result) => {
                                    if (result.isConfirmed) {
                                        props.sendRejection()
                                    }
                                }
                            );
                        }}
                        CancelButtonText='Rechazar' />
                </div>
            }
        </Box>}
    />)
}